// Replaces the old chest.js / rewards.js dailyChest flow with a single
// shake-on-availability button. Stores the last-claimed date as an ISO
// string in user.lastDailyReward — independent of the legacy
// user.dailyChest field so old data is effectively ignored.

import { getUser } from './views';
import { saveUserData } from '../auth/kindeClient';
import { updateStats } from './stats';

const DAILY_REWARD_KEY = 'lastDailyReward';

function isClaimedToday(user) {
    if (!user) return true;
    const raw = user[DAILY_REWARD_KEY];
    if (!raw) return false;
    const last = new Date(raw);
    const today = new Date();
    last.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    return last.getTime() === today.getTime();
}

function generateReward() {
    // Always at least some coins; mana/gems are bonus chances.
    const coins = Math.floor(Math.random() * 51) + 50; // 50..100
    let mana = 0, gems = 0;
    if (Math.random() < 0.10) mana = 1;
    else if (Math.random() < 0.30) gems = Math.floor(Math.random() * 3) + 1;
    return { coins, mana, gems };
}

function showRewardModal(reward) {
    const modal = document.getElementById('dailyRewardResult');
    if (!modal) return;
    document.getElementById('rewardManaLine').textContent  = `Mana:  ${reward.mana}`;
    document.getElementById('rewardCoinsLine').textContent = `Coins: ${reward.coins}`;
    document.getElementById('rewardGemsLine').textContent  = `Gems:  ${reward.gems}`;
    modal.style.display = 'flex';
    const close = document.getElementById('dailyRewardClose');
    if (close) {
        close.onclick = () => { modal.style.display = 'none'; };
    }
    modal.onclick = (e) => {
        if (e.target === modal) modal.style.display = 'none';
    };
}

function refreshDailyRewardButton() {
    const btn = document.getElementById('dailyRewardButton');
    if (!btn) return;
    const user = getUser();
    const claimed = isClaimedToday(user);
    btn.classList.toggle('claimed', claimed);
    btn.disabled = claimed;
    const label = btn.querySelector('.action-label');
    if (label) label.textContent = claimed ? 'Come back tomorrow' : 'Daily Reward';
}

function wireDailyRewardButton() {
    const btn = document.getElementById('dailyRewardButton');
    if (!btn || btn.dataset.wired === '1') return;
    btn.dataset.wired = '1';

    btn.addEventListener('click', async () => {
        const user = getUser();
        if (!user) return;
        if (isClaimedToday(user)) return;
        // Lock during the brief save round-trip.
        btn.disabled = true;
        btn.classList.remove('shake');
        const reward = generateReward();
        user.coins = (user.coins || 0) + reward.coins;
        user.mana  = (user.mana  || 0) + reward.mana;
        user.gems  = (user.gems  || 0) + reward.gems;
        user[DAILY_REWARD_KEY] = new Date().toISOString();
        updateStats(user.mana, user.coins, user.gems);
        showRewardModal(reward);
        // Fire-and-forget save — the UI has already updated and the local
        // lastDailyReward will prevent re-claims until next day.
        saveUserData();
        refreshDailyRewardButton();
    });
}

export function initDailyReward() {
    wireDailyRewardButton();
    refreshDailyRewardButton();
}

export { refreshDailyRewardButton };
